import { useIsOwner } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { minicrudsClient } from '../../../../utils/apollo/api'
import { useMinicrudsActionsList } from '../../../../utils/actions/minicruds/list'
import { useMinicrudsPermission } from '../../../../utils/helpers/minicrudsPermission'
import { useMinicrudsState } from '../_load/MinicrudsLoader'
import { useOpenEditMinicrudModal } from '../../../../utils/routes/modals/modalsActions'
import { useRouteParam } from '../../../../utils/routes/helpers/useParam'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../packages/kiti/components/actions/Link'
import ListCounter from '../../../../components/helpers/ListCounter'
import Text from '../../../../packages/kiti/components/presentation/Text'

const MinicrudsTable = props => {
  const { t } = useTranslation('minicruds')
  const { minicruds: data } = useMinicrudsState()
  const isOwner = useIsOwner()
  const entity = useRouteParam('entity')
  const canEdit = useMinicrudsPermission(entity)
  const onEdit = useOpenEditMinicrudModal()

  const columns = [
    {
      label: t('name'),
      headerSideContent: (
        <>
          <ListCounter
            client={minicrudsClient}
            entity="minicrud"
            filterName="MinicrudFilter"
            size="xsmall"
            filters={{ entities: entity }}
            bold
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 4,
      render: (name, record) => (
        <Link onClick={() => (canEdit ? onEdit(record) : undefined)}>
          <Text>{name}</Text>
        </Link>
      )
    },

    {
      label: t('actions'),
      width: 5,
      render: useRowActionsColumn(useMinicrudsActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" {...props} />
}

export default MinicrudsTable
